import { NavLink, useNavigate } from "react-router-dom";
import { navForRole } from "@/config/nav";
import { useAuth } from "@/context/AuthContext";
import { cn } from "@/lib/utils";
import { LogOut } from "lucide-react";

export function SidebarContent({ onNavigate }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const items = navForRole(user?.role);

  const doLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <div className="flex h-full flex-col bg-navy text-slate-300">
      <div className="flex items-center px-4 h-16 bg-white border-b border-slate-200 shrink-0">
        <img src="/medoho-logo.png" alt="Medoho — Digital Power for Doctors" className="h-9 w-auto" />
      </div>

      <nav className="flex-1 overflow-y-auto medoho-scroll px-3 py-4 space-y-1">
        {items.map((item) => (
          <NavLink
            key={item.to + item.label}
            to={item.to}
            onClick={onNavigate}
            data-testid={`nav-${item.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
            className={({ isActive }) =>
              cn(
                "flex items-center gap-3 rounded-lg px-3 min-h-[44px] text-sm font-medium transition-colors",
                isActive
                  ? "bg-teal text-white shadow-sm"
                  : "text-slate-300 hover:bg-white/5 hover:text-white"
              )
            }
          >
            <item.icon className="h-[18px] w-[18px] shrink-0" />
            <span className="truncate">{item.label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="p-3 border-t border-white/10 shrink-0">
        <button
          onClick={doLogout}
          data-testid="sidebar-logout-btn"
          className="flex w-full items-center gap-3 rounded-lg px-3 min-h-[44px] text-sm font-medium text-slate-300 hover:bg-white/5 hover:text-white transition-colors"
        >
          <LogOut className="h-[18px] w-[18px]" />
          Sign out
        </button>
      </div>
    </div>
  );
}
